import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import "./QuotationItem.scss";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import { memo } from "react";

/* Version prix par personne
const QuotationItem = ({ description, price, isBasePrice, quantity, unitPrice }) => {
	const sign = price > 0 ? "+" : "-";

	const pricePrefix = isBasePrice ? "" : <AmountSign sign={sign} />;

	return (
		<div
			className={classNames({
				"quotation-item": true,
				"quotation-item--base-price": isBasePrice,
			})}
		>
			<div className="quotation-item__description" data-testid="quotation-item-label">
				{description}
			</div>
			<div className="quotation-item__price" data-testid="quotation-item-price">
				{price === 0 ? (
					<FormattedMessage id="price.detail.offered.label" />
				) : (
					<>
						{quantity > 1 ? `${quantity} x ` : ""}
						<AmountContainer
							amount={Math.abs(unitPrice && quantity ? unitPrice : price)}
							prefix={pricePrefix}
						/>
					</>
				)}
			</div>
		</div>
	);
};

QuotationItem.propTypes = {
	description: PropTypes.string,
	price: PropTypes.number,
	quantity: PropTypes.number,
	unitPrice: PropTypes.number,
	isBasePrice: PropTypes.bool,
};

export default memo(QuotationItem);
*/

const QuotationItem = ({ description, price, isBasePrice }) => {
	const sign = price > 0 ? "+" : "-";

	const pricePrefix = isBasePrice ? "" : <AmountSign sign={sign} />;

	return (
		<div
			className={classNames({
				"quotation-item": true,
				"quotation-item--base-price": isBasePrice,
			})}
		>
			<div className="quotation-item__description" data-testid="quotation-item-label">
				{description}
			</div>
			<div className="quotation-item__price" data-testid="quotation-item-price">
				{price === 0 ? (
					<FormattedMessage id="price.detail.offered.label" />
				) : (
					<AmountContainer amount={Math.abs(price)} prefix={pricePrefix} />
				)}
			</div>
		</div>
	);
};

QuotationItem.propTypes = {
	description: PropTypes.string,
	price: PropTypes.number,
	isBasePrice: PropTypes.bool,
};

export default memo(QuotationItem);
